import React from 'react'
import FadeInSectionDownToUp from '../../Components/FadeAnimations/FadeInSectionDownToUp'
import { FaHeart } from 'react-icons/fa'
import { FaLocationDot } from "react-icons/fa6";
import FadeInSectionRightToLeft from '../../Components/FadeAnimations/FadeInSectionRightToLeft';
import FadeInSectionLeftToRight from '../../Components/FadeAnimations/FadeInSectionLeftToRight';
import Slider from '../../Components/Travel/Slider/Slider';
import Marquee from 'react-fast-marquee'
import { motion } from "framer-motion";

export default function Travel() {

    const testimonials = [
        {
            name: 'John Doe',
            quote: '"A Dream Vacation Come True!"',
            feedback: `I booked my honeymoon through this website and had the most amazing experience. 
      From the seamless booking process to the personalized recommendations, everything was perfect.`,
            image: 'https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg',
            colour: "bg-[#0D8F94]",
        },
        {
            name: 'John Doe',
            quote: '"A Dream Vacation Come True!"',
            feedback: `I booked my honeymoon through this website and had the most amazing experience. 
      From the seamless booking process to the personalized recommendations, everything was perfect.`,
            image: 'https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg',
            colour: "bg-[#FF6557]",
        },
        {
            name: 'John Doe',
            quote: '"A Dream Vacation Come True!"',
            feedback: `I booked my honeymoon through this website and had the most amazing experience. 
      From the seamless booking process to the personalized recommendations, everything was perfect.`,
            image: 'https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg',
            colour: "bg-[#FFDF48]",
        },
        {
            name: 'John Doe',
            quote: '"A Dream Vacation Come True!"',
            feedback: `I booked my honeymoon through this website and had the most amazing experience. 
      From the seamless booking process to the personalized recommendations, everything was perfect.`,
            image: 'https://static.vecteezy.com/system/resources/previews/002/002/403/non_2x/man-with-beard-avatar-character-isolated-icon-free-vector.jpg',
            colour: "bg-[#FF6557]",
        },
        // 🔁 Add more testimonial objects here...
    ];

    return (
        <div>
            <div className="bg-gradient-to-b from-sky-400 to-white h-screen relative overflow-hidden">
                {/* 🎈 Decorative Images */}
                {/* <img className="w-80 absolute top-20 left-0 z-10" src="https://albidayahgroups.com/Media/Travel/53.png" alt="AB-Holidays" />
                <img className="w-96 absolute top-20 right-0 z-10" src="https://albidayahgroups.com/Media/Travel/54.png" alt="AB-Holidays" />
                <img className="w-40 absolute top-20 left-60 z-10" src="https://albidayahgroups.com/Media/Travel/Layer%202.png" alt="AB-Holidays" />
                <img className="w-20 absolute top-1/2 -left-10 blur-sm z-0" src="https://albidayahgroups.com/Media/Travel/Layer%202.png" alt="AB-Holidays" />
                <img className="w-20 absolute bottom-0 left-1/4 z-0" src="https://albidayahgroups.com/Media/Travel/Layer%202.png" alt="AB-Holidays" />
                <img className="w-20 absolute top-0 left-1/2 z-0" src="https://albidayahgroups.com/Media/Travel/Layer%202.png" alt="AB-Holidays" />
                <img className="w-60 absolute top-1/2 left-3/4 z-10" src="https://albidayahgroups.com/Media/Travel/BALLOON.png" alt="AB-Holidays" />
                <img className="w-80 absolute top-0 left-1/3 z-0" src="https://albidayahgroups.com/Media/Travel/50.png" alt="AB-Holidays" />
                <img className="w-80 absolute bottom-0 right-0 z-0" src="https://albidayahgroups.com/Media/Travel/50.png" alt="AB-Holidays" /> */}

                <motion.img
  className="w-80 absolute top-20 left-0 z-10"
  src="https://albidayahgroups.com/Media/Travel/53.png"
  alt="AB-Holidays"
  initial={{ x: -100, opacity: 0 }}
  animate={{ x: 0, opacity: 1 }}
  transition={{ duration: 1, delay: 0.2 }}
/>

<motion.img
  className="w-96 absolute top-20 right-0 z-10"
  src="https://albidayahgroups.com/Media/Travel/54.png"
  alt="AB-Holidays"
  initial={{ x: 100, opacity: 0 }}
  animate={{ x: 0, opacity: 1 }}
  transition={{ duration: 1, delay: 0.4 }}
/>

<motion.img
  className="w-40 absolute top-20 left-60 z-10"
  src="https://albidayahgroups.com/Media/Travel/Layer%202.png"
  alt="AB-Holidays"
  initial={{ y: -50, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ duration: 1, delay: 0.6 }}
/>

<motion.img
  className="w-20 absolute top-1/2 -left-10 blur-sm z-0"
  src="https://albidayahgroups.com/Media/Travel/Layer%202.png"
  alt="AB-Holidays"
  initial={{ x: -30, opacity: 0 }}
  animate={{ x: 0, opacity: 1 }}
  transition={{ duration: 1, delay: 0.3 }}
/>

<motion.img
  className="w-20 absolute bottom-0 left-1/4 z-0"
  src="https://albidayahgroups.com/Media/Travel/Layer%202.png"
  alt="AB-Holidays"
  initial={{ y: 30, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ duration: 1, delay: 0.5 }}
/>

<motion.img
  className="w-20 absolute top-0 left-1/2 z-0"
  src="https://albidayahgroups.com/Media/Travel/Layer%202.png"
  alt="AB-Holidays"
  initial={{ y: -30, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ duration: 1, delay: 0.7 }}
/>

{/* 🎈 Balloon Wiggle Animation */}
<motion.img
  className="w-60 absolute top-1/2 left-3/4 z-10"
  src="https://albidayahgroups.com/Media/Travel/BALLOON.png"
  alt="AB-Holidays"
  animate={{
    y: [0, -10, 0],         // Up and down
    rotate: [0, 2, -2, 0],   // Small rotation wiggle
  }}
  transition={{
    duration: 3,
    repeat: Infinity,
    ease: "easeInOut"
  }}
/>

<motion.img
  className="w-80 absolute top-0 left-1/3 z-0"
  src="https://albidayahgroups.com/Media/Travel/50.png"
  alt="AB-Holidays"
  initial={{ y: -40, opacity: 0 }}
  animate={{ y: 0, opacity: 1 }}
  transition={{ duration: 1.2, delay: 0.5 }}
/>

<motion.img
  className="w-80 absolute bottom-0 right-0 z-0"
  src="https://albidayahgroups.com/Media/Travel/50.png"
  alt="AB-Holidays"
  initial={{ x: 50, opacity: 0 }}
  animate={{ x: 0, opacity: 1 }}
  transition={{ duration: 1.2, delay: 0.6 }}
/>


                {/* ✏️ Text Content */}
                <div className="relative z-20 flex items-center h-full px-6 md:px-20">
                    <div className="text-white max-w-3xl">
                        <FadeInSectionDownToUp>
                            <h1 className="text-6xl max-sm:text-3xl text-[#56202F] font-bold mb-6 leading-tight">
                                Travel Smarter. Explore<br />
                                Deeper. <span className="text-[#8A38F5]">Live Fully.</span>
                            </h1>
                            <p className="text-2xl max-sm:text-xl text-[#56202F]">
                                We craft travel experiences that are joyful, seamless, and tailored just <br className="max-sm:hidden" />
                                for you. Let the adventure begin!
                            </p>
                        </FadeInSectionDownToUp>
                    </div>
                </div>
            </div>
            <div>
                <div className="flex max-sm:flex-col justify-between items-center max-sm:space-y-8 bg-white relative z-50 border-2 rounded-3xl px-40 max-sm:px-5 py-6 mx-40 max-sm:mx-5 -mt-40">
                    {/* Item 1 */}
                    <FadeInSectionDownToUp>
                        <div className="flex items-center gap-3">
                            <div className="bg-black p-2 rounded-full">
                                <FaHeart color="white" size={30} />
                            </div>
                            <p className="text-2xl leading-snug">
                                5,000+ Happy <br className='max-sm:hidden' />
                                Travelers Served
                            </p>
                        </div>
                    </FadeInSectionDownToUp>

                    {/* Separator */}
                    <div className="h-24 max-sm:h-0.5 w-0.5 max-sm:w-full rounded-full bg-black mx-4" />

                    {/* Item 2 */}
                    <FadeInSectionDownToUp>
                        <div className="flex items-center gap-3">
                            <div className="bg-black p-2 rounded-full">
                                <FaLocationDot color="white" size={30} />
                            </div>
                            <p className="text-2xl leading-snug">
                                100+ Destinations <br className='max-sm:hidden' />
                                Covered
                            </p>
                        </div>
                    </FadeInSectionDownToUp>
                </div>
            </div>
            <div>
                <div className="relative z-10 flex max-sm:flex-col items-center gap-20 max-sm:gap-10 h-full px-5 md:px-16 py-20">
                    <div className="text-black w-full">
                        <FadeInSectionLeftToRight>
                            <p className="text-4xl max-sm:text-4xl text-[#420110] font-bold mb-4 leading-tight">
                                About<br /> <span className='text-[#FF9E69] text-6xl max-sm:text-4xl'>AB-Holidays</span>
                            </p>
                            <p className="text-lg md:text-xl text-[#420110]  text-justify">
                                With a proud legacy of excellence in the travel industry, AL-Bi Holidays has been
                                turning journeys into unforgettable memories for years. From humble beginnings to
                                becoming a trusted name in travel, our passion for exploring the world and serving our
                                customers has only grown stronger. We specialize in crafting personalized travel
                                experiences - whether it’s a family vacation, a romantic escape, a corporate retreat,
                                or a group adventure. Our deep local expertise, global partnerships, and commitment
                                to exceptional service make every trip with us seamless, safe, and truly enriching. At
                                AL-Bi Holidays, we don’t just plan holidays - we help you live your travel dreams.
                            </p>
                        </FadeInSectionLeftToRight>
                    </div>
                    <div className="w-full">
                        <FadeInSectionRightToLeft>
                            <img className='rounded-2xl aspect-square w-full h-[500px] object-cover' src='https://albidayahgroups.com/Media/Travel/img.png' alt='AL-BIDAYAH' />
                        </FadeInSectionRightToLeft>
                    </div>
                </div>
            </div>
            <div>
                <div className='px-20 max-sm:px-5 space-y-10'>
                    <p className="text-4xl max-sm:text-4xl text-[#420110] font-bold mb-4 leading-tight">
                        Our Best Services !
                    </p>
                    <div>
                        <Slider />
                    </div>
                </div>
            </div>
            <div className='px-20 max-sm:px-5 py-10 max-sm:py-5'>
                <div>
                    <FadeInSectionDownToUp>
                        <p className="text-3xl max-sm:text-2xl text-[#420110] font-bold mb-4 leading-tight">
                            What Our Customer’s Says ?
                        </p>
                    </FadeInSectionDownToUp>
                </div>
                <div className='max-sm:pb-20'>
                    <Marquee pauseOnHover={true} speed={50} gradient={false} className="gap-8">
                        {testimonials.map((t, i) => (
                            <div
                                key={i}
                                className="relative border-2 rounded-2xl m-4 p-6 min-w-[400px] max-w-sm"
                            >
                                {/* 👤 Avatar & Content */}
                                <FadeInSectionDownToUp>
                                    <div className="flex items-start gap-4">
                                        <img
                                            className="rounded-full w-20 h-20 object-cover"
                                            src={t.image}
                                            alt={t.name}
                                        />
                                        <div className="text-gray-700">
                                            <p className="font-bold text-lg mb-2">{t.quote}</p>
                                            <p className="text-sm">{t.feedback}</p>
                                        </div>
                                    </div>
                                </FadeInSectionDownToUp>

                                {/* 🎨 Decorative Clip-Path Circle */}
                                <div className={`absolute bottom-0 left-0 w-20 h-20 ${t.colour} z-0 clip-circle rounded-bl-2xl`} />
                            </div>
                        ))}
                    </Marquee>
                </div>
            </div>
        </div>
    )
}
